import script from "./AddReview.vue?vue&type=script&setup=true&lang=js"
export * from "./AddReview.vue?vue&type=script&setup=true&lang=js"

import "./AddReview.vue?vue&type=style&index=0&id=6bc8684d&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bc8684d"]])

export default __exports__